// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"0dd706c2","90":"4053e5de","157":"b41dca45","204":"1ad48546","415":"5cf9b939","478":"0196c694","619":"4b7cc9af","635":"bd15266d","703":"bf08fb0c"}[chunkId] + ".chunk.js";
};